export interface IGlobalProperty {
  key: string;
  value: string;
  description: string;
}

export enum EGlobalPropertyTypes {
  DateFormat = 'date_format',
}
